import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { ArrowLeft, MailCheck } from "lucide-react";

export default function WachtwoordVergeten() {
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(null); // {bericht, reset_url}

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const { data } = await api.post("/auth/wachtwoord-vergeten", {
        email,
        app_base_url: window.location.origin,
      });
      setDone(data);
    } catch {
      setDone({ bericht: "Als dit e-mailadres bekend is, is er een herstellink aangemaakt.", reset_url: null });
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-background">
      <Card className="w-full max-w-md border-border shadow-none" data-testid="wachtwoord-vergeten-card">
        <CardHeader>
          <CardTitle className="font-display text-3xl">Wachtwoord vergeten</CardTitle>
          <CardDescription>Vul je e-mailadres in. Je ontvangt een link om een nieuw wachtwoord in te stellen.</CardDescription>
        </CardHeader>
        <CardContent>
          {!done ? (
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">E-mail</Label>
                <Input id="email" type="email" required data-testid="vergeten-email"
                  value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="email" />
              </div>
              <Button type="submit" className="w-full h-11" disabled={busy} data-testid="vergeten-submit">
                {busy ? "Bezig…" : "Herstellink aanvragen"}
              </Button>
            </form>
          ) : (
            <div className="space-y-4" data-testid="vergeten-bevestiging">
              <div className="flex items-start gap-2 rounded-lg bg-emerald-50 border border-emerald-200 text-emerald-800 px-3 py-2.5 text-sm">
                <MailCheck className="h-4 w-4 mt-0.5 shrink-0" /> {done.bericht}
              </div>
              {done.reset_url && (
                <div className="space-y-2 rounded-lg border border-border bg-secondary/40 p-3">
                  <div className="text-xs text-muted-foreground">
                    Er wordt nog geen echte e-mail verstuurd. Gebruik onderstaande link om je wachtwoord te herstellen:
                  </div>
                  <Link to={done.reset_url} data-testid="vergeten-reset-link">
                    <Button className="w-full" variant="outline">Naar herstelpagina</Button>
                  </Link>
                </div>
              )}
            </div>
          )}
          <Link to="/login" className="mt-5 inline-flex items-center gap-1 text-sm text-primary hover:underline">
            <ArrowLeft className="h-3.5 w-3.5" /> Terug naar inloggen
          </Link>
        </CardContent>
      </Card>
    </div>
  );
}
